/*
  Brilinton site frame intersections.
  Adds the small corner/intersection marks used by the section linework system.
*/
(function () {
  function applySiteFrameIntersections() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var positions = [
      'top-left-vertical', 'top-left-horizontal',
      'top-right-vertical', 'top-right-horizontal',
      'bottom-left-vertical', 'bottom-left-horizontal',
      'bottom-right-vertical', 'bottom-right-horizontal'
    ];

    main.querySelectorAll('.shopify-section').forEach(function (section) {
      if (section.dataset.siteFrameIntersections === 'true') return;
      section.dataset.siteFrameIntersections = 'true';

      positions.forEach(function (position) {
        var span = document.createElement('span');
        span.className = 'intersecting ' + position;
        span.setAttribute('aria-hidden', 'true');
        section.appendChild(span);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySiteFrameIntersections);
  } else {
    applySiteFrameIntersections();
  }

  document.addEventListener('shopify:section:load', applySiteFrameIntersections);
})();
